import { Tooltip, type TooltipProps } from '@chakra-ui/react';

export type UiTooltipProps = TooltipProps;

export const UiTooltip = Tooltip;
